import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import CrmVendedoresDetailsView from './details';
import CrmVendedoresListView from './list';
import { useContext } from '@components';
export default angular
    .module('app.crm.vendedores', [])
    .config(routes)
    .component('crmVendedoresDetailsView', react2angular(useContext.use(CrmVendedoresDetailsView), [], ['$state', 'CrmService', 'AuthorizationService']))
    .component('crmVendedoresListView', react2angular(useContext.use(CrmVendedoresListView), [], ['$state', 'CrmService'])).name;
